import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=7c7cfdcc&scoped=true&lang=pug&"
import script from "./FormItem.vue?vue&type=script&lang=js&"
export * from "./FormItem.vue?vue&type=script&lang=js&"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=7c7cfdcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7cfdcc",
  null
  
)

export default component.exports